(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc-helpers.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc-helpers.js');
'use strict';

const getReturnUrl = () => {
  const queryUrl = svs.utils.url.queryString.returnUrl;
  return queryUrl ? svs.utils.url.makeInternal(queryUrl) : undefined;
};
svs.myProfile.react.pages.kyc.kycHelpers = {
  getReturnUrl
};

 })(window);